import HttpClient from "../base/http-client";

export default class UserGroupClient extends HttpClient {
  constructor() {
    super("user-groups");
    this.isAuth = true;
  }
}
